import { SEARCH_STRING_LOCALIZATION_KEY, landingSupportedLanguages } from '@next/shared';
import type { i18n } from 'i18next';
import { Localization } from 'shared/types';

export type TParams = {
    [index: number]: string | number;
};

export const i18nLocalizationService = ({
    i18n,
    t,
    onLocaleChanged,
}: {
    i18n: i18n;
    t: (key: string, params?: TParams) => string;
    onLocaleChanged?: (locale: string) => void;
}): Localization => {
    return {
        set: localization => {
            i18n.changeLanguage(localization)
                .then(() => {
                    const url = new URL(window.location.href);
                    const locale = url.searchParams.get(SEARCH_STRING_LOCALIZATION_KEY);

                    if (locale) {
                        url.searchParams.set(SEARCH_STRING_LOCALIZATION_KEY, localization);
                        history.pushState(history.state, document.title, url.toString());
                    }

                    onLocaleChanged?.(localization);
                })
                .catch((error: unknown) => {
                    console.error('Can not change localization', {
                        localization,
                        error,
                    });
                });
        },
        get: (key: string, params = []) => {
            if (!key) return '';

            if (params.length > 0) {
                const paramsObj = params.reduce<TParams>((obj, item, index) => {
                    obj[index] = item;

                    return obj;
                }, {});
                return t(key, paramsObj);
            }
            return t(key);
        },
        getCurrentLanguage: () => i18n.language,
        getAvailableLanguages: () => landingSupportedLanguages,
        getCommon: (key, options) => {
            return key;
        },
        getCurrentLanguageInfo: () => ({
            code: 0,
            encoding: '',
            nativeName: '',
            tag: '',
            urlTag: '',
        }),
        getLocalizedDate: (date, locale, options) => date.toLocaleString(),
        getLocalizedDateTime: (date, locale, options) => date.toLocaleString(),
        getLocalizedTime: (date, locale, options) => {
            return date.toLocaleString();
        },
    };
};
